import type {KeyTextField} from '@prismicio/client'
import type {Top10AiToolsSliceDefaultPrimaryTrendsItem} from 'prismicio-types'
import React from 'react'

interface Props {
  eyebrow: KeyTextField
  title: KeyTextField
  trends: Top10AiToolsSliceDefaultPrimaryTrendsItem[]
}

const Trends: React.FC<Props> = ({eyebrow, title, trends}) => (
  <section className="t10-section t10-section-alt">
    <div className="t10-wrap">
      {eyebrow && <p className="t10-eyebrow">{eyebrow}</p>}
      {title && (
        <h2 className="t10-section-title" style={{maxWidth: '22ch', marginBottom: 48}}>
          {title}
        </h2>
      )}
      {trends && trends.length > 0 && (
        <div className="t10-trends-grid">
          {trends.map((t, i) => {
            const numColor = t.num && t.num.startsWith('−') ? '#FF7A7A' : '#B4FF44'
            return (
              <div key={i} className="t10-trend-card">
                <div className="t10-trend-num" style={{color: numColor}}>
                  {t.num}
                </div>
                <h3 className="t10-trend-title">{t.title}</h3>
                <p className="t10-trend-desc">{t.desc}</p>
              </div>
            )
          })}
        </div>
      )}
    </div>
  </section>
)

export default Trends
